import React, { Fragment } from "react";
import AuthorCard from "@/components/author-card";
import Comments from "@/components/comments";
import blogDetailsImage from "@/images/blog/7.jpg";

const SinglePostCard = ({blog}) => {
  const {image, title, date, content} = blog;
  return (
    <Fragment>
      <div className="single_blog">
        <div className="blog_thumb">
          <img src={image} alt="" />
        </div>
        <div className="blog_headings">
          <span className="blog_date">{date}</span>
          <h2>{title}</h2>
          {/* <p className="blog_metas">
            <a href="#">By Author</a>-<a href="#">30 Likes</a>-
            <a href="#">2 Comments</a>
          </p> */}
        </div>
        <div className="blog_details">
          <div dangerouslySetInnerHTML={{__html:content}} />
        </div>
        <div className="blog_tagitems">
          <span>Tags:</span>
          <a href="#">Logistics</a>, <a href="#">Transporation</a>,{" "}
          <a href="#">Digital</a>, <a href="#">Technology</a>
        </div>
        {/* <AuthorCard />
        <Comments /> */}
      </div>
    </Fragment>
  );
};

export default SinglePostCard;
